import React from "react";
import { changeTitle } from "../data/GeneralFunction";

export default function Courses() {
  changeTitle("Findwine | Courses");

  return <div>Courses</div>;
}
